import {Component, Input, OnChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {DeviceParamGatewayV3Network} from '../../../../../../shared/classes/device/type-gateway-v3/device-param-gateway-v3-network';

@Component({
    selector: 'app-param-networks',
    templateUrl: './param-networks.component.html',
    styleUrls: ['./param-networks.component.css']
})
export class ParamNetworksComponent implements OnChanges {


    public currentTriggerDataIndexForEdition: number = null;

    public deviceParamGatewayV3NetworkForm: FormGroup;
    public showDeviceParamGatewayV3NetworkForm: boolean = false;


    @Input('deviceParamGatewayV3Network') deviceParamGatewayV3Network: DeviceParamGatewayV3Network[];
    @Input('editable') editable: boolean = true;

    constructor(private toastr: ToastrService,
                private translate: TranslateService) {
    }

    ngOnChanges() {
        if (!this.deviceParamGatewayV3Network) {
            return;
        }
        if (this.deviceParamGatewayV3NetworkForm) {
            return;
        }
        this.initDeviceParamGatewayV3NetworkForm();
        this.setDefaultData();
    }

    setDefaultData() {
        if (this.deviceParamGatewayV3Network.length < 2) {

            let net0: DeviceParamGatewayV3Network = new DeviceParamGatewayV3Network();
            net0.type = 'ethernet';
            net0.get_ip = 'stat';
            net0.iface = 'eth0';
            net0.ip = '192.168.5.20';
            net0.netmask = '255.255.0.0';
            net0.gw = '192.168.5.1';
            net0.dns = '8.8.8.8';


            let net1: DeviceParamGatewayV3Network = new DeviceParamGatewayV3Network();
            net1.type = 'wifi';

            let net2: DeviceParamGatewayV3Network = new DeviceParamGatewayV3Network();
            net2.type = 'lte';

            this.deviceParamGatewayV3Network.push(net0);
            this.deviceParamGatewayV3Network.push(net1);
            this.deviceParamGatewayV3Network.push(net2);


        }

    }

    setEditable() {
        this.initDeviceParamGatewayV3NetworkForm();
        this.showDeviceParamGatewayV3NetworkForm = true;
    }

    initDeviceParamGatewayV3NetworkForm() {
        this.showDeviceParamGatewayV3NetworkForm = false;
        this.deviceParamGatewayV3NetworkForm = new FormGroup({
            type: new FormControl('', [Validators.required]),
            get_ip: new FormControl(''),
            iface: new FormControl(''),
            ip: new FormControl(''),
            netmask: new FormControl(''),
            gw: new FormControl(''),
            dns: new FormControl(''),
            ssid: new FormControl(''),
            security: new FormControl(''),
            psk: new FormControl(''),
            pincode: new FormControl('')

        });
    }

    addTriggerData() {
        let amp = new DeviceParamGatewayV3Network();
        if (this.deviceParamGatewayV3NetworkForm.valid) {
            amp.type = this.deviceParamGatewayV3NetworkForm.value.type;
            amp.get_ip = this.deviceParamGatewayV3NetworkForm.value.get_ip;
            amp.iface = this.deviceParamGatewayV3NetworkForm.value.iface;
            amp.ip = this.deviceParamGatewayV3NetworkForm.value.ip;
            amp.netmask = this.deviceParamGatewayV3NetworkForm.value.netmask;
            amp.gw = this.deviceParamGatewayV3NetworkForm.value.gw;
            amp.dns = this.deviceParamGatewayV3NetworkForm.value.dns;
            amp.ssid = this.deviceParamGatewayV3NetworkForm.value.ssid;
            amp.security = this.deviceParamGatewayV3NetworkForm.value.security;
            amp.psk = this.deviceParamGatewayV3NetworkForm.value.psk;
            amp.pincode = this.deviceParamGatewayV3NetworkForm.value.pincode;


            this.toastr.success(' added', this.translate.instant('SUCCESS'));
            this.deviceParamGatewayV3Network.push(amp);
            this.initDeviceParamGatewayV3NetworkForm();

        } else {
            this.toastr.error('fill all fields !', this.translate.instant('SUCCESS'));
        }
    }

    editTriggerData() {
        if (this.deviceParamGatewayV3NetworkForm.valid) {
            let i = this.currentTriggerDataIndexForEdition;
            this.deviceParamGatewayV3Network[i].type = this.deviceParamGatewayV3NetworkForm.value.type;
            this.deviceParamGatewayV3Network[i].get_ip = this.deviceParamGatewayV3NetworkForm.value.get_ip;
            this.deviceParamGatewayV3Network[i].iface = this.deviceParamGatewayV3NetworkForm.value.iface;
            this.deviceParamGatewayV3Network[i].ip = this.deviceParamGatewayV3NetworkForm.value.ip;
            this.deviceParamGatewayV3Network[i].netmask = this.deviceParamGatewayV3NetworkForm.value.netmask;
            this.deviceParamGatewayV3Network[i].gw = this.deviceParamGatewayV3NetworkForm.value.gw;
            this.deviceParamGatewayV3Network[i].dns = this.deviceParamGatewayV3NetworkForm.value.dns;
            this.deviceParamGatewayV3Network[i].ssid = this.deviceParamGatewayV3NetworkForm.value.ssid;
            this.deviceParamGatewayV3Network[i].security = this.deviceParamGatewayV3NetworkForm.value.security;
            this.deviceParamGatewayV3Network[i].psk = this.deviceParamGatewayV3NetworkForm.value.psk;
            this.deviceParamGatewayV3Network[i].pincode = this.deviceParamGatewayV3NetworkForm.value.pincode;


            this.toastr.success(' #' + this.currentTriggerDataIndexForEdition + ' modified', this.translate.instant('SUCCESS'));
            this.currentTriggerDataIndexForEdition = null;
            this.initDeviceParamGatewayV3NetworkForm();

        } else {
            this.toastr.error('fill all fields !', this.translate.instant('ERROR'));
        }
    }

    setFormWithTriggerData(i: number) {

        this.initDeviceParamGatewayV3NetworkForm();
        this.showDeviceParamGatewayV3NetworkForm = true;
        this.currentTriggerDataIndexForEdition = i;
        this.deviceParamGatewayV3NetworkForm.setValue({
            type: this.deviceParamGatewayV3Network[i].type,
            get_ip: this.deviceParamGatewayV3Network[i].get_ip !== undefined ? this.deviceParamGatewayV3Network[i].get_ip : '',
            iface: this.deviceParamGatewayV3Network[i].iface !== undefined ? this.deviceParamGatewayV3Network[i].iface : '',
            ip: this.deviceParamGatewayV3Network[i].ip !== undefined ? this.deviceParamGatewayV3Network[i].ip : '',
            netmask: this.deviceParamGatewayV3Network[i].netmask !== undefined ? this.deviceParamGatewayV3Network[i].ip : '',
            gw: this.deviceParamGatewayV3Network[i].gw !== undefined ? this.deviceParamGatewayV3Network[i].gw : '',
            dns: this.deviceParamGatewayV3Network[i].dns !== undefined ? this.deviceParamGatewayV3Network[i].dns : '',
            ssid: this.deviceParamGatewayV3Network[i].ssid !== undefined ? this.deviceParamGatewayV3Network[i].ssid : '',
            security: this.deviceParamGatewayV3Network[i].security !== undefined ? this.deviceParamGatewayV3Network[i].security : '',
            psk: this.deviceParamGatewayV3Network[i].psk !== undefined ? this.deviceParamGatewayV3Network[i].psk : '',
            pincode: this.deviceParamGatewayV3Network[i].pincode !== undefined ? this.deviceParamGatewayV3Network[i].pincode : ''
        });
        this.toastr.success('You can now edit  #' + this.currentTriggerDataIndexForEdition, this.translate.instant('SUCCESS'));
    }

    cancelTriggerData() {
        this.currentTriggerDataIndexForEdition = null;
        this.initDeviceParamGatewayV3NetworkForm();

    }

    removeTriggerData(i: number) {
        this.deviceParamGatewayV3Network.splice(i, 1);
        this.toastr.warning(' #' + i + ' removed', this.translate.instant('SUCCESS'));
    }

}
